// avoid pulling in all of pa-react which adds 750k to build package and slows build time
import URLParametersService from 'pa-react/dist/util/URLParametersService';

import { PRODUCT, PRODUCT_TYPE, ProductType, EIPProductIdType } from 'constants/product';

//
// --- Types ---

interface UseQueryParametersReturn {
  contractId?: number;
  gridWidgetId?: number;
  gridWidgetInitialWidth?: number; // a number, 1-6 representing columns panel covers
  gridWidgetType?: string;
  isDiscovery?: boolean;
  offeringKey?: number;
  portalId?: number;
  productKey: EIPProductIdType;
  productType?: ProductType;
  searchTerm?: string;
}

//
// --- Helper ---

function getProductKeyForProductType(productType: ProductType | undefined): EIPProductIdType {
  return productType === PRODUCT_TYPE.SOURCING
    ? PRODUCT.SOURCING_INTELLIGENCE
    : productType === PRODUCT_TYPE.PORTAL
    ? PRODUCT.SUPPLIER_INTELLIGENCE
    : productType === PRODUCT_TYPE.CONTRACT
    ? PRODUCT.CONTRACT_INTELLIGENCE
    : PRODUCT.MARKET_INTELLIGENCE;
}

function getProductTypeFromQueryParams(
  contractId?: string,
  offeringKey?: string,
  portalId?: string
): ProductType | undefined {
  return contractId
    ? PRODUCT_TYPE.CONTRACT
    : portalId
    ? PRODUCT_TYPE.PORTAL
    : offeringKey
    ? PRODUCT_TYPE.SOURCING
    : undefined;
}

//
// ---- useQueryParameters Hook ---

export const useQueryParameters = (): UseQueryParametersReturn => {
  const {
    contractId,
    isDiscovery,
    location,
    okey: offeringKey,
    portalId,
    searchTerm,
    widgetId: gridWidgetId,
    widgetInitialWidth: gridWidgetInitialWidth,
    widgetType: gridWidgetType
  } = URLParametersService.getQueryParamObject();

  const productType = getProductTypeFromQueryParams(contractId, offeringKey, portalId);

  if (isDiscovery && (location === PRODUCT_TYPE.MARKET || location === PRODUCT_TYPE.SOURCING)) {
    return {
      gridWidgetId: gridWidgetId ? parseInt(gridWidgetId, 10) : undefined,
      gridWidgetInitialWidth: gridWidgetInitialWidth ? parseInt(gridWidgetInitialWidth, 10) : undefined,
      gridWidgetType,
      isDiscovery: !!isDiscovery,
      productKey: getProductKeyForProductType(location),
      productType: location,
      searchTerm
    };
  }

  return {
    contractId: contractId ? parseInt(contractId, 10) : undefined,
    isDiscovery: !!isDiscovery,
    offeringKey: offeringKey ? parseInt(offeringKey, 10) : undefined,
    portalId: portalId ? parseInt(portalId, 10) : undefined,
    productKey: getProductKeyForProductType(productType),
    productType
  };
};
